import template from './contactInsurancesList.template.html';

export default {
  template,
  bindings: {
    insurances: '<',
    contact: '<',
    onEdit: '&',
    onDelete: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, listServiceNew) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
      ctrl.currentLocale = $rootScope.CurrentLocale();
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.list.setData(ctrl.insurances);
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.insuranceEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.insuranceDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.insurances) {
          ctrl.initialize();
        }
      };
    }
  }
};
